module.exports = __webpack_public_path__ + "img/oufu_32x45x6b.prt.5ebafad0.jpg";